module.exports = __webpack_public_path__ + "static/media/login_image.a9b3ab58.svg";